export const Retake = [{
  path: 'retake',
  component: () => import('../../../components/router-view'),
  children: [
    {
      path: '',
      name: 'AdminRetake',
      component: () => import('../../../components/Admin/Retake.vue'),
      meta: {
        access: ['admin', 'examiner']
      }
    },
    {
      path: 'create',
      name: 'RetakeCreate',
      component: () => import('../../../components/Admin/CreateRetake.vue'),
      meta: {
        access: ['admin', 'examiner']
      }
    },
    {
      path: 'edit/:id',
      name: 'RetakeEdit',
      component: () => import('../../../components/Admin/EditRetake.vue'),
      meta: {
        access: ['admin', 'examiner']
      }
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/router/admin/module/retake.js